module.exports = __webpack_public_path__ + "img/how-icon-2-appoint.d9b17bc5.png";